import { useContext, useState } from "react";
import { citiesContext } from "../../ContextAPI/Cities";
import { searchUsers } from "../../actions/index";
import SelectBox from "../Login/SelectBox";
import Table from "./Table";
import findMatchIMG from "../../Assets/findMatch.png";
import Loader from "../../component/Loader/Loader";
import { motion } from "framer-motion";
import BloodType from "../BloodType/BloodType";
import "./styles.css";

const initialState = {
  bloodType: "",
  address: ""
};
const bloodType = ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-"];

const FindMatch = () => {
  const cities = useContext(citiesContext);
  const [province, setProvince] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [matchedUsers, setMatchedUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleProvinceChange = (e) => {
    setProvince(e.target.value);
  };
  const handleFormChange = (e) => {
    setFormData((prev) =>
      setFormData({ ...prev, [e.target.name]: e.target.value })
    );
  };
  const findMatch = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(null);
      const users = await searchUsers(formData);
      console.log(users);
      setIsLoading(false);
      setMatchedUsers(users.message);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <motion.section
      initial={{ opacity: 0, transform: "translateY(10%)" }}
      animate={{ opacity: 1, transform: "translateY(0%)" }}
      exit={{ opacity: 0 }}
      className="findmatch"
    >
      <div className="container">
        <div className="findmatch__container">
          <div className="findmatch__form">
            <div className="image">
              <img src={findMatchIMG} />
            </div>
            <h1>Trouver votre correspondance</h1>
            <form onChange={handleFormChange}>
              <div className="search__inputs">
                <SelectBox
                  name="province"
                  id="auth-province"
                  options={Object.keys(cities)}
                  label="Province"
                  onChange={handleProvinceChange}
                />
                <SelectBox
                  name="address"
                  id="auth-city"
                  options={cities[province]}
                  label="Ville"
                />
                <SelectBox
                  name="bloodType"
                  id="auth-bloodType"
                  options={bloodType}
                  label="Choisir Groupe Sanguin"
                />
              </div>
              <div className="search__button">
                <button className="btn btn-primary" onClick={findMatch}>
                  <span>Trouver</span>
                  {isLoading ?? <Loader />}
                </button>
              </div>
            </form>
            <div className="result">
              {matchedUsers?.length ? (
                <>
                  <Table users={matchedUsers} />
                </>
              ) : null}
            </div>
          </div>
        </div>
        <BloodType />
      </div>
    </motion.section>
  );
};
export default FindMatch;
